export default __webpack_public_path__ + "static/matthewkiernander-53a52b230f6b9d316d0fd3b536b5e706.jpg";